module.exports = __webpack_public_path__ + "fonts/cges-icons.ecbab420.ttf";